<div class="time">
  <!----------------------->
  <!-------- HOUR --------->
  <!----------------------->
  <div class="time-container">
    <button (click)="incrementHour()" mat-icon-button aria-label="Increase hour" class="time-container_increament">
      <dr-customer-offers-ui-icons name="expand_less" size="extra-small"></dr-customer-offers-ui-icons>
    </button>

    <mat-form-field
      class="time-container__textbox small-height"
      appearance="outline"
      subscriptSizing="dynamic"
      [ngClass]="{ 'mat-form-field-invalid': invalidForm }"
      name="formStartHour"
    >
      <input [formControl]="hourFormControl" class="time-container__textbox--input" matInput name="hour12" placeholder="Hour" />
    </mat-form-field>

    <button (click)="decrementHour()" mat-icon-button aria-label="Decrease hour" class="time-container_decreament">
      <dr-customer-offers-ui-icons name="expand_more" size="extra-small"></dr-customer-offers-ui-icons>
    </button>
  </div>

  <span class="content-colon">:</span>

  <!----------------------->
  <!------- MINUTE -------->
  <!----------------------->
  <div class="time-container">
    <button (click)="incrementMinuteByFrequency()" mat-icon-button aria-label="Increase minute" class="time-container_increament">
      <dr-customer-offers-ui-icons name="expand_less" size="extra-small"></dr-customer-offers-ui-icons>
    </button>

    <mat-form-field
      class="time-container__textbox small-height"
      appearance="outline"
      subscriptSizing="dynamic"
      [ngClass]="{ 'mat-form-field-invalid': invalidForm }"
      name="minutes"
    >
      <input
        [formControl]="minuteFormControl"
        readonly
        class="time-container__textbox--input"
        matInput
        placeholder="21"
        name="minutes"
        [value]="minuteFormControl.value"
      />
    </mat-form-field>

    <button (click)="decrementMinuteByFrequency()" mat-icon-button class="time-container_decreament" aria-label="Decrease minute">
      <dr-customer-offers-ui-icons name="expand_more" size="extra-small"></dr-customer-offers-ui-icons>
    </button>
  </div>
</div>

<!----------------------->
<!------- PERIOD -------->
<!----------------------->
<div class="mat-button-container--toggle mat-button-container--toggle-border period">
  <mat-button-toggle-group [formControl]="periodFormControl" name="hourPeriod" aria-label="Time Format Toggle">
    <mat-button-toggle value="am">{{ 'COM.LABELS.AM' | translate }}</mat-button-toggle>
    <mat-button-toggle value="pm">{{ 'COM.LABELS.PM' | translate }}</mat-button-toggle>
  </mat-button-toggle-group>
</div>

<mat-error class="mt-3">{{ hourErrors | translate }}</mat-error>
